module.exports = __webpack_public_path__ + "static/media/score_icon.641ff562.png";